import { Star, Quote, ShieldCheck } from "lucide-react";

// Real verified testimonials from UrbanPro (4.9/5, 71 reviews)
const stories = [
  {
    name: "Nilofar Sande",
    role: "Verified Student · Selenium with Java",
    date: "Apr 2025",
    text: "I recommend BYMAT Automation by Rahul Sir to anyone looking to enter the Automation Testing industry, whether with or without prior experience. The teaching quality meets industry standards right from Day one. You'll learn key interview questions and strategies to handle interviews effectively. Enrolling in this course will definitely give you a competitive edge.",
    rating: 5,
  },
  {
    name: "Akshay Vaidya",
    role: "Got Job in MNC · Selenium Automation",
    date: "Jan 2025",
    text: "Only because of this training my confidence boosted up and after completing half course only I got job in MNC. Thank you very much Rahul sir for providing such a wonderful training. If you are thinking of learning Automation Testing then Rahul sir and BYMAT Automation is the best choice.",
    rating: 5,
  },
  {
    name: "Sagar Gabhane",
    role: "3-Month Training Graduate",
    date: "Apr 2025",
    text: "I had the privilege of undergoing a 3-month training program under Rahul Sir's guidance, and it was an amazing experience! The course covered Selenium, Java, and various web elements in great detail. By the end of the training, I felt confident in using Selenium for automation testing.",
    rating: 5,
  },
  {
    name: "Bhumi K",
    role: "Zero Coding Background · Selenium",
    date: "Apr 2025",
    text: "Very happy with Rahul Sir's style of teaching. He explained things clearly and made them easy to understand — and the best part is recording is available for all sessions. Someone who has zero knowledge in automation testing and coding can easily understand.",
    rating: 5,
  },
  {
    name: "Deepika B",
    role: "Selenium with Java · 3-Month Course",
    date: "Dec 2024",
    text: "I successfully completed a 3-month Selenium with Java automation course taught by Rahul. He is an excellent instructor who thoroughly covered all aspects of Java and Selenium. Rahul provided comprehensive course materials, including code content and recorded videos after each session.",
    rating: 5,
  },
  {
    name: "Shweta Meshram",
    role: "Selenium Automation · Pune",
    date: "Dec 2024",
    text: "The training exceeded my expectations. The trainer was highly knowledgeable and experienced in both Selenium and automation testing. Practical demonstrations were a key highlight — every concept was reinforced with hands-on exercises. I highly recommend this Selenium Automation trainer to anyone looking to learn automation testing in-depth.",
    rating: 5,
  },
];

export default function SocialProof() {
  return (
    <section
      id="stories"
      className="relative py-20 md:py-32 px-6 md:px-10 bg-[#0A1628]"
      data-testid="social-proof-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 max-w-5xl">
          <div className="max-w-3xl">
            <div className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#38BDF8]">
              Real Student Reviews
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-normal text-white mt-4 leading-tight">
              <span className="text-[#38BDF8]">4.9 / 5</span> from verified reviews.
              <br />
              <span className="text-slate-400">Stories from real learners.</span>
            </h2>
          </div>
          <a
            href="https://www.urbanpro.com/pune/rahul-ganjare/reviews/13402861"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[#38BDF8] border border-slate-700 hover:border-[#38BDF8]/40 rounded-full px-4 py-2 transition-colors"
            data-testid="urbanpro-link"
          >
            <ShieldCheck className="w-4 h-4 text-[#38BDF8]" />
            Read all reviews on UrbanPro
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {stories.map((s, i) => (
            <div
              key={i}
              className="card-hover bg-white/[0.03] backdrop-blur-xl border border-white/10 rounded-2xl p-7 relative overflow-hidden"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="absolute top-5 right-5 w-10 h-10 text-[#38BDF8]/10" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: s.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-[#38BDF8] text-[#38BDF8]" />
                ))}
              </div>
              <p className="text-slate-200 leading-relaxed text-[15px]">"{s.text}"</p>
              <div className="mt-6 pt-5 border-t border-white/10">
                <div className="font-normal text-white flex items-center gap-2">
                  {s.name}
                  <ShieldCheck className="w-3.5 h-3.5 text-[#38BDF8]" title="Verified Student" />
                </div>
                <div className="text-xs text-slate-400 mt-1">{s.role}</div>
                <div className="text-[11px] text-slate-500 mt-1">Reviewed {s.date}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
